import CoopPriceProjectionInterface from "@app/Interface/CoopPriceProjectionInterface";
import DashboardCurrentComponentsInterface from "@app/Interface/DashboardCurrentComponentsInterface";
import DashboardDataInterface from "@app/Interface/DashboardDataInterface";
import ErrorResponseInterface from "@app/Interface/ErrorResponseInterface";
import MontanaPriceProjectionInterface from "@app/Interface/MontanaPriceProjectionInterface";
import WeightedAverageInterface from "@app/Interface/WeightedAverageInterface";
import DashboardCurrentComponentsModel from "./DashboardCurrentComponentsModel";

export default class DashboardDataModel implements DashboardDataInterface {
    id: number;
    currentComponents: DashboardCurrentComponentsInterface;
    monthToDate: WeightedAverageInterface[] | ErrorResponseInterface;
    pricingCoop: CoopPriceProjectionInterface[] | ErrorResponseInterface;
    pricingMontana: MontanaPriceProjectionInterface[] | ErrorResponseInterface;
    
    constructor(data?: DashboardDataInterface) {
        this.id = data?.id ?? 0;
        this.currentComponents = data?.currentComponents ?? new DashboardCurrentComponentsModel();
        this.monthToDate = data?.monthToDate ?? [];
        this.pricingCoop = data?.pricingCoop ?? [];
        this.pricingMontana = data?.pricingMontana ?? [];
    }
}